var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.68645 -2.75888e-08 5.44447 0.802193 3.65607 2.2699C1.86767 3.7376 0.643499 5.78 0.192147 8.0491C-0.259205 10.3182 0.090186 12.6736 1.18079 14.714C2.27139 16.7543 4.03572 18.3534 6.17316 19.2388C8.31061 20.1242 10.6889 20.241 12.9028 19.5694C15.1168 18.8978 17.0294 17.4794 18.3147 15.5557C19.6 13.6321 20.1786 11.3222 19.9518 9.01983C19.7251 6.71742 18.707 4.56486 17.0711 2.92893L15.6722 4.32782C16.9845 5.64011 17.8011 7.36682 17.983 9.21374C18.165 11.0607 17.7008 12.9135 16.6698 14.4566C15.6387 15.9997 14.1045 17.1375 12.3286 17.6763C10.5526 18.215 8.64482 18.1213 6.93024 17.4111C5.21565 16.7009 3.80036 15.4181 2.92551 13.7814C2.05067 12.1447 1.7704 10.2552 2.13246 8.43505C2.49452 6.61485 3.47651 4.9765 4.9111 3.79916C6.3457 2.62182 8.14414 1.97832 10 1.97832V0Z",
    fill: "url(#loader-gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loader-gradient",
    x1: 9,
    y1: 8.5,
    x2: 18.5,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738785,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.414f4f68.svg";
export { ForwardRef as ReactComponent };